<template>
    <div>


        <b-field grouped group-multiline>


            <div class="control">
                <b-taglist attached>
                    <b-tag type="is-light" class="has-text-grey-darker is-size-6 tag-border-header">OPD No.</b-tag>
                    <b-tag type="is-warning is-light" class="has-text-grey-dark is-size-6 tag-border-data">{{dataToDisplay.idopd}}</b-tag>
                </b-taglist>

            </div>

            <div class="control">
                <b-taglist attached>
                    <b-tag type="is-light" class="has-text-grey-darker is-size-6 tag-border-header">Pet Name</b-tag>
                    <b-tag type="is-warning is-light"  class="has-text-grey-dark is-size-6 tag-border-data">{{dataToDisplay.name}}</b-tag>
                </b-taglist>
            </div>


            <div class="control">
                <b-taglist attached>
                    <b-tag type="is-light" class="has-text-grey-darker is-size-6 tag-border-header">Owner</b-tag>
                    <b-tag type="is-warning is-light"  class="has-text-grey-dark is-size-6 tag-border-data">{{dataToDisplay.owner_name}}</b-tag>
                </b-taglist>
            </div>


            <div class="control">
                <b-taglist attached>
                    <b-tag type="is-light" class="has-text-grey-darker is-size-6 tag-border-header">Gender</b-tag>
                    <b-tag type="is-warning is-light"  class="has-text-grey-dark is-size-6 tag-border-data">
                        <b-icon
                                :icon="dataToDisplay.sex === 'M' ? 'gender-male' : 'gender-female'">
                        </b-icon>

                        </b-tag>
                </b-taglist>
            </div>

            <div class="control">
                <b-taglist attached>
                    <b-tag type="is-light" class="has-text-grey-darker is-size-6 tag-border-header">age</b-tag>
                    <b-tag type="is-warning is-light"  class="has-text-grey-dark is-size-6 tag-border-data">{{dataToDisplay.age}}</b-tag>
                </b-taglist>
            </div>


            <div class="control">
                <b-taglist attached>
                    <b-tag type="is-light" class="has-text-grey-darker is-size-6 tag-border-header">Species</b-tag>
                    <b-tag type="is-warning is-light" class="has-text-grey-dark is-size-6 tag-border-data">{{dataToDisplay.species}}</b-tag>
                </b-taglist>
            </div>

            <div class="control">
                <b-taglist attached  >
                    <b-tag type="is-light"  class="has-text-grey-darker is-size-6 tag-border-header" >Breed</b-tag>
                    <b-tag type="is-warning is-light" class="has-text-grey-dark is-size-6 tag-border-data" >{{dataToDisplay.breed}}</b-tag>
                </b-taglist>
            </div>




        </b-field>
        <br>


    </div>
</template>

<script>
    export default {
        name: "OPDInfo",
        props:{
            dataToDisplay : Object
        }
    }
</script>

<style scoped>
  .tag-border-header{
      border:1px solid #00b89c;
  }
  .tag-border-data{
      border-bottom :1px solid #00b89c;
      border-right:1px solid #00b89c;
      border-top:1px solid #00b89c;
  }
</style>